import cssTree from 'css-tree';
import { CssFilesAllowedProperties } from './CssAllowedProperties';

export const cssValidator = (cssString) => {
    const parseErrors = [];
    try {
        const ast = cssTree.parse(cssString, {
            positions: true,
            onParseError: (error) => {
                parseErrors.push(new Error(error.formattedMessage));
            },
        });

        cssTree.walk(ast, (node) => {
            if (node.type === 'Raw') {
                parseErrors.push(new Error(`Raw node found: "${node.value}"`));
            }

            // Check if property is in allowed properties
            if (node.type === 'Declaration' && !CssFilesAllowedProperties.includes(node.property)) {
                parseErrors.push(new Error(`Property "${node.property}" is not allowed.`));
            }

            // Block expression()
            if (node.type === 'Function' && node.name.toLowerCase() === 'expression') {
                parseErrors.push(new Error(`Usage of expression() is not allowed.`));
            }

            // Block url()
            if (node.type === 'Url') {
                const value = node.value?.value || '';
                parseErrors.push(new Error(`Usage of url("${value}") is not allowed.`));
            }
        });

        return parseErrors;
    } catch (error) {
        return [error];
    }
};
